import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';
import { JobNames } from '../../framework.core/JobNames';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import SecondaryButton from '../../ui/SecondaryButton';
import ApplicationContext from '../../ApplicationContext';
import { emailOptionItem } from '../accounting/tableSettings';
import { ApplicableTableSettings } from '../../tableSettings';
import CheckBox from '../../ui/CheckBox';
import SmartTable from '../../uiControls/SmartTable';
import { TextAlignLeftRenderer } from '../../uiControls/SmartTableRenderers';

interface emailOptionData {
  email: string,
  isSelect: boolean
}

function EmailOptionImpl({
  jobId,
  storageKey,
  onClose,
  jobName,
  isUsedTrackingRequest,
}: {
  jobId: number,
  storageKey: string,
  onClose: (x: any) => void,
  jobName: JobNames,
  isUsedTrackingRequest: boolean,
}) {
  const appContext = useContext(ApplicationContext);

  const [initialized, setInitialized] = useState(false);

  const emailListRef = useRef('')
  const emailCntRef = useRef(0);
  const [displayData, setDisplayData] = useState<emailOptionData[]>([]);

  const [data, setData, removeData, ] = useTypedFastStorage<boolean>(storageKey, null);

  useEffect(() => {
    initialize();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function doClose(emailList: string = '') {
    cleanup();
    onClose(emailList);
  }

  function cleanup() {
    removeData();
  }

  async function loadExisting() {
    const result: string = await appContext.api.getCompaniesToNotify(jobName, jobId);
    // if (!result) {
    //   await showGlobalOkDialog('Cannot load data');
    //   doClose();
    //   return;
    // }

    return result;
  }

  function addReservedEmail(email: string) {
    emailListRef.current = emailListRef.current + email;
    emailCntRef.current = emailCntRef.current + 1;

    return { email, isSelect: false };
  }

  async function getCode(id: string) {
    let tempList: emailOptionData[] = [];

    //Company Profile의 Email도 표시되도록 Email 추가
    if(!_.isEmpty(appContext.systemSettings?.companyProfile?.email)){
      tempList.push(addReservedEmail(appContext.systemSettings?.companyProfile?.email ?? ''));
    }

    if (isUsedTrackingRequest && !_.isEmpty(appContext.user?.email)) {
      tempList.push(addReservedEmail(appContext.user?.email ?? ''));
    }

    if (!_.isEmpty(id)) {
      let Add: string = String.fromCharCode(127);
      const comList: string[] = id.split(String.fromCharCode(127));

      for (let i = 0; i < comList.length; i++) {
        if (comList[i].trim() === '') continue;

        const arg = comList[i].split('|');
        if (arg.length === 1) {
          const ipos = Add.indexOf(String.fromCharCode(127) + arg[0] + String.fromCharCode(127));
          if (parseInt(arg[0]) > 0 && ipos === -1) {
            if (i === 0) {
              id = arg[0];
            }

            const adoList = await appContext.api.getCode(arg[0], appContext.user?.email);
            if (adoList !== null) {
              for (let j = 0; j < adoList.length; j++) {
                const s = adoList[j].DEPT + ' ' + adoList[j].F_EMAIL;
                tempList.push({ email: s, isSelect: false });

                emailListRef.current = emailListRef.current + (adoList[j].F_EMAIL.length > 0 ? adoList[j].F_EMAIL + ';' : '');
                Add = Add + adoList[j].F_ID + String.fromCharCode(127);
                emailCntRef.current = emailCntRef.current + 1;
              }
            }
          }
        } else {
          tempList.push({ email: arg[4], isSelect: false });
          emailListRef.current = emailListRef.current + arg[4];
          emailCntRef.current = emailCntRef.current + 1;
        }
      }
      // if (tempList.length > 0) {
      //   tempList[0].isSelect = true;
      // }
    }
    return tempList;
  }

  async function initialize() {
    if (!data) {
      const comIds = await loadExisting();
      setDisplayData(await getCode(String(comIds ?? '')));
      setData(true);
    }
    setInitialized(true);
  }

  if (!initialized || !data) {
    return null;
  }

  return (
    <div className='report-popup'>
      {!initialized &&
        <div style={{ position: 'relative', top: '-25px' }}>
          <SkeletonTheme color="#4287f5" highlightColor="#b9d2fa">
            <Skeleton count={1} height={2} />
          </SkeletonTheme>
        </div>
      }

      <EmailOptionInitializedImpl
        close={doClose}
        displayData={displayData}
        setDisplayData={setDisplayData}
        isUsedTrackingRequest={isUsedTrackingRequest}
      />
    </div>
  );
}

function EmailOptionInitializedImpl({
  close,
  displayData,
  setDisplayData,
  isUsedTrackingRequest,
}: {
  close: (x: any) => void,
  displayData: emailOptionData[],
  setDisplayData: any
  isUsedTrackingRequest: boolean,
}) {
  // const [showGlobalOkDialog] = useGlobalOkDialog();

  async function btnOk() {
    if (isUsedTrackingRequest) {
      if (!displayData.some(x => x.isSelect)) {
        // await showGlobalOkDialog(<p>Please select email</p>);
        close('');
        return;
      }

      let temp: string;
      let emailText: string[] = [];

      let EmailList: string = "";
      const tempList = displayData.filter(x => x.isSelect);

      for (let i = 0; i < tempList.length; i++) {
        temp = tempList[i].email;
        emailText = temp.split(']');

        if (emailText.length >= 2) {
          EmailList += emailText[1] + ";";
        } else {
          EmailList += temp + ";";
        }
      }

      if (EmailList.length > 2)
        EmailList = EmailList.substring(0, EmailList.length - 1).trimLeft();

      close(EmailList);
      return;
    }
    close(undefined);
  }

  function toggleSelection(i: number) {
    const tempList = _.cloneDeep(displayData).map(item => {
      return item;
    });
    tempList[i].isSelect = !tempList[i].isSelect;
    setDisplayData(tempList);
  }

  function SelectRenderer({ data, row }: any) {
    const toggleSelection = data[0].toggleSelection;
    const l = data[row.index];

    return (
      <div style={{ width: '100%' }}>
        <CheckBox
          value={l.isSelect}
          onChange={() => toggleSelection(row.index)}
        />
      </div>
    );
  }

  const tableOptions: ApplicableTableSettings = {
    tableName: 'emailoptiontable',
    ...emailOptionItem,
    height: '300px',
    data: displayData.map((x, i) => ({
      ...x,
      i,
      toggleSelection,
    })),
    rowRenderers: [
      { accessor: 'email', Cell: TextAlignLeftRenderer },
      { accessor: 'select', Cell: SelectRenderer },
    ],
    headersColor: 'gray',
  };

  const RenderedTable = React.useMemo(() => <SmartTable {...tableOptions} />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [displayData]);

  return (
    <div id='emailoptionpopup'>
      <div style={{ display: 'flex' }}>
        <div style={{ marginTop: '10px', width: '710px' }}>
          {RenderedTable}
        </div>
      </div>

      <div className='report-footer'>
        <SecondaryButton
          size="regular"
          style={{ width: '60px' }}
          onClick={btnOk}>
          Ok
        </SecondaryButton>
        <SecondaryButton
          size="regular"
          style={{ width: '60px' }}
          onClick={() => close('')}>
          Cancel
        </SecondaryButton>
      </div>
    </div>
  );
}

const EmailOptionPopup = ({
  jobId,
  storageKey,
  onClose,
  jobName,
  isUsedTrackingRequest,
}: {
  jobId: number,
  storageKey: string,
  onClose: (x: any) => void,
  jobName: JobNames,
  isUsedTrackingRequest: boolean
}) => {
  return (
    <EmailOptionImpl
      jobId={jobId}
      jobName={jobName}
      key={storageKey}
      storageKey={storageKey}
      onClose={onClose}
      isUsedTrackingRequest={isUsedTrackingRequest}
    />
  );
};

EmailOptionPopup.defaultProps = {
};

EmailOptionPopup.propTypes = {
  jobId: PropTypes.number.isRequired,
  storageKey: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EmailOptionPopup;